import api from "./api";
import log from "loglevel";

const state = {};

// getters
const getters = {};

// actions
const actions = {
  async getContentsPageList(context, params) {
    try {
      const res = await api.getContentsPageList(params);
      return {
        status: res.status,
        imageUrls: res.data.imageUrls,
        scrambleWidth: res.data.scrambleWidth,
        scrambleHeight: res.data.scrambleHeight,
        contentsTitle: res.data.contentsTitle
      };
    } catch (error) {
      log.error("getContentsPageList error:", error);
      context.commit("common/setError", error, { root: true });
      return error.status;
    }
  }
};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
